import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 保存
  mobilesourceCheckSave(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/save',
      method: 'post',
      data: data
    })
  },
  // 详情
  mobilesourceCheckgetById(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/getById/' + id,
      method: 'get'
    })
  },
  // 删除
  mobilesourceCheckremove(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/remove/' + id,
      method: 'get'
    })
  },
  // 全部问题列表
  mobilesourceCheckpageAll(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/pageAll',
      method: 'get',
      params: params
    })
  },
  // 我的提交列表
  mobilesourceCheckpageCreate(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/pageCreate',
      method: 'get',
      params: params
    })
  },
  // 我的处理列表
  mobilesourceCheckpageDeal(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/pageDeal',
      method: 'get',
      params: params
    })
  },
  // 通知我的列表
  mobilesourceCheckpageNotice(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheck/pageNotice',
      method: 'get',
      params: params
    })
  },
  // 问题处理
  mobilesourceDealsaveDeal(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerHistory/saveDeal',
      method: 'post',
      data: data
    })
  },
  // 问题审核
  mobilesourceDealsaveCheck(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerHistory/saveCheck',
      method: 'post',
      data: data
    })
  },
  // 漏检记录
  projectDangerCheckLogpage(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheckLog/page',
      method: 'get',
      params: params
    })
  },
  // 漏检详情
  projectDangerCheckgetById(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDangerCheckLog/getById/' + id,
      method: 'get'
    })
  }
}




// WEBPACK FOOTER //
// ./src/api/inspectionmobile/index.js